import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';


const ActionButtons = ({ orderNumber }) => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(30);
  const [autoRedirect, setAutoRedirect] = useState(true);

  useEffect(() => {
    if (autoRedirect && countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (autoRedirect && countdown === 0) {
      navigate('/order-history');
    }
  }, [countdown, autoRedirect, navigate]);

  const handleContinueShopping = () => {
    navigate('/');
  };

  const handleTrackOrder = () => {
    navigate('/order-history');
  };

  const handlePrintReceipt = () => {
    window.print();
  };

  const handleCancelAutoRedirect = () => {
    setAutoRedirect(false);
  };

  return (
    <div className="space-y-6">
      {/* Auto-redirect Notice */}
      {autoRedirect && countdown > 0 && (
        <div className="bg-muted border border-border rounded-lg p-4 text-center">
          <p className="text-sm text-muted-foreground mb-2">
            Redirecting to order tracking in {countdown} seconds...
          </p>
          <Button
            variant="outline"
            size="sm"
            onClick={handleCancelAutoRedirect}
            iconName="X"
            iconPosition="left"
          >
            Cancel Auto-redirect
          </Button>
        </div>
      )}

      {/* Primary Actions */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Button
          variant="default"
          size="lg"
          onClick={handleContinueShopping}
          iconName="ShoppingBag"
          iconPosition="left"
          fullWidth
        >
          Continue Shopping
        </Button>
        
        <Button
          variant="outline"
          size="lg"
          onClick={handleTrackOrder}
          iconName="Package"
          iconPosition="left"
          fullWidth
        >
          Track Order
        </Button>
        
        <Button
          variant="secondary"
          size="lg"
          onClick={handlePrintReceipt}
          iconName="Printer"
          iconPosition="left"
          fullWidth
        >
          Print Receipt
        </Button>
      </div>

      {/* Secondary Actions */}
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Button
          variant="ghost"
          onClick={() => navigate('/user-account-dashboard')}
          iconName="User"
          iconPosition="left"
        >
          View Account
        </Button>
        
        <Button
          variant="ghost"
          onClick={() => window.open(`mailto:?subject=Check out my purchase!&body=I just ordered from DevOra! Order #${orderNumber}`, '_blank')}
          iconName="Share"
          iconPosition="left"
        >
          Share Purchase
        </Button>
      </div>
    </div>
  );
};

export default ActionButtons;